export default __webpack_public_path__ + "ddf89ca9f1d5b3ca976acf5f45cd1d8e.png";